import ItemActions from './ItemActions'

module.exports = ItemActions.create( { 
  parentName : 'system', 
  itemsName : 'users', 
  actionTypeBase : 'SYSTEM_USER', 
  parentIdKey : 'systemId', 
  humanItemName : 'User',
  isUser : true
} )
